(() => {
  const pageHandle = window.location.pathname.match(/^\/pages\/([^/?#]+)/)?.[1];
  const supportedPages = new Set(['switchback-system', 'cruiser', 'cruiser-city']);

  if (!supportedPages.has(pageHandle)) return;

  const sourceFilesHost = 'https://goveer.com/cdn/shop/files/';
  const repairedImages = new WeakSet();

  function sourceFileUrl(value) {
    if (!value || !value.includes('/cdn/shop/files/')) return value;

    const [, tail = ''] = value.split('/cdn/shop/files/');
    const [path, query = ''] = tail.split('?');
    const width = new URLSearchParams(query.replaceAll('&amp;', '&')).get('width');
    return `${sourceFilesHost}${path}${width ? `?width=${width}` : ''}`;
  }

  function sourceSrcset(value) {
    if (!value) return value;
    return value
      .split(',')
      .map((candidate) => {
        const parts = candidate.trim().split(/\s+/);
        parts[0] = sourceFileUrl(parts[0]);
        return parts.join(' ');
      })
      .join(', ');
  }

  function repairPicture(image) {
    if (!(image instanceof HTMLImageElement) || repairedImages.has(image)) return;
    if (!image.currentSrc.includes('/cdn/shop/files/') && !image.src.includes('/cdn/shop/files/')) return;

    repairedImages.add(image);
    const picture = image.closest('picture');

    picture?.querySelectorAll('source[srcset]').forEach((source) => {
      source.srcset = sourceSrcset(source.getAttribute('srcset'));
    });

    if (image.hasAttribute('srcset')) {
      image.srcset = sourceSrcset(image.getAttribute('srcset'));
    }
    if (image.hasAttribute('src')) {
      image.src = sourceFileUrl(image.getAttribute('src'));
    } else {
      image.src = sourceFileUrl(image.currentSrc);
    }
  }

  function watchImage(image) {
    if (!(image instanceof HTMLImageElement)) return;
    image.addEventListener('error', () => repairPicture(image), { once: true });
    if (image.complete && image.naturalWidth === 0) repairPicture(image);
  }

  const colorKit = {
    variants: [
      {
        name: 'Rose Quartz',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-RQTZ_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/Rose_Quartz_Master.png?v=1742673845&width=40'
      },
      {
        name: 'Blue Beryl',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-BBRL_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/switchback-color-kit-luxe-blue-beryl.png?v=1716216689&width=40'
      },
      {
        name: 'Brown Mica',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-BMIC_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/custom-sidewall-kit-brown-mica_copy_3.png?v=1735750569&width=40'
      },
      {
        name: 'Green Jasper',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-GJAS_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/switchback-color-kit-luxe-green-jasper.png?v=1728394477&width=40'
      },
      {
        name: 'Natural',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-NAT_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/custom-sidewall-kit-natural.png?v=1716217129&width=40'
      },
      {
        name: 'Gray Granite',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SBSEAT-GGRA_1.png?v=1773841322&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/retractable-canopy-gray-granite.png?v=1716213303&width=40'
      },
      {
        name: 'Black Onyx',
        image: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/SKIT-2-BONX_transparent_48117b9f-9cda-4b73-93d1-39d1bff09e3d.png?v=1784304921&width=grande',
        swatch: 'https://cdn.shopify.com/s/files/1/0697/9574/2010/files/Black_Onyx_Master.png?v=1773243156&width=40'
      }
    ]
  };

  function mountSwitchbackColorKit() {
    if (pageHandle !== 'switchback-system') return;
    const section = document.querySelector('[id$="__1884ef0d-a76d-41a3-a32b-bc124231ce2b"]');
    const container = section?.querySelector('[data-block-color-feature]');
    if (!container || container.children.length) return;

    const first = colorKit.variants[0];
    container.innerHTML = `
      <div class="product-color-card fade color-feature gcc-color-kit-card">
        <div class="product-color-card__images">
          <a href="/products/switchback-color-kit-luxe" aria-label="Switchback Color Kit Luxe" class="product-color-card__image"></a>
          <img src="${first.image}" loading="lazy" alt="Switchback Color Kit Luxe" data-gcc-color-kit-image>
        </div>
        <div class="product-color-card__content">
          <div class="product-color-card__swatches color-feature" data-gcc-color-kit-swatches></div>
        </div>
      </div>`;

    const image = container.querySelector('[data-gcc-color-kit-image]');
    const swatches = container.querySelector('[data-gcc-color-kit-swatches]');

    colorKit.variants.forEach((variant, index) => {
      const item = document.createElement('div');
      item.className = 'swatch-container';
      item.innerHTML = `
        <button aria-label="${variant.name}" type="button" class="product-color-card__swatch color-feature${index === 0 ? ' product-color-card__swatch--active' : ''}">
          <img src="${variant.swatch}" alt="${variant.name}" aria-hidden="true">
        </button>
        <span class="button-text product-color-card__swatch-name${index === 0 ? ' product-color-card__swatch-name--active' : ''}">${variant.name}</span>`;

      item.querySelector('button').addEventListener('click', () => {
        image.src = variant.image;
        swatches.querySelectorAll('.product-color-card__swatch--active').forEach((node) => node.classList.remove('product-color-card__swatch--active'));
        swatches.querySelectorAll('.product-color-card__swatch-name--active').forEach((node) => node.classList.remove('product-color-card__swatch-name--active'));
        item.querySelector('button').classList.add('product-color-card__swatch--active');
        item.querySelector('span').classList.add('product-color-card__swatch-name--active');
      });
      swatches.appendChild(item);
    });
  }

  function mountProductCarouselControls() {
    document.querySelectorAll('section-product-carousel').forEach((section) => {
      const track = section.querySelector('[data-gcc-product-carousel-track]');
      if (!track || track.dataset.gccControlsReady === 'true') return;
      track.dataset.gccControlsReady = 'true';
      const amount = () => Math.max(280, Math.min(track.clientWidth * 0.82, 720));
      section.querySelector('[data-product-carousel-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
      section.querySelector('[data-product-carousel-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    });
  }

  function scan(root = document) {
    root.querySelectorAll?.('img').forEach(watchImage);
  }

  function init() {
    scan();
    mountSwitchbackColorKit();
    mountProductCarouselControls();
    scan();

    const mutations = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('img')) watchImage(node);
          scan(node);
        });
      });
      mountSwitchbackColorKit();
      mountProductCarouselControls();
    });
    mutations.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
